<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="hero-text">
        The tool for recruiters who value their time. We keep it simple
      </h1>
      <h2 class="subtitle-text">
        Post your job offer on different job boards with only one submision on Job Boardy
      </h2>
    </div>

    <div class="features-container">
      <div class="feature">
        <div class="icon-container">
          <i class="fas fa-search icon"></i>
        </div>
        <div>
          <h3>Find specific job boards</h3>
          <p class="secondary-text">
            We have a large selection of popular and niche job boards. You can filter them by categories, places and keywords.
          </p>
        </div>
      </div>
      <div class="feature">
        <div class="icon-container">
          <i class="far fa-file-alt icon"></i>
        </div>
        <div>
          <h3>We give you a curated job form</h3>
          <p class="secondary-text">
            An easy to fill job description template with only a few quick steps. Also we give you the option to personalize your job
            description.
          </p>
        </div>
      </div>
      <div class="feature">
        <div class="icon-container">
          <i class="fas fa-chart-line icon"></i>
        </div>
        <div>
          <h3>Keep tracking the status of your job offers</h3>
          <p class="secondary-text">
            Daily updates of where your job offer has been sent to. This is the best way to keep tracking the performance of your job posts.
          </p>
        </div>
      </div>
      <div class="feature">
        <div class="icon-container">
          <i class="far fa-clock icon"></i>
        </div>
        <div>
          <h3>Save time</h3>
          <p class="secondary-text">
            We know you're busy searching the most valuable talents. That's why JobBoardy will send your job offers for you.
          </p>
        </div>
      </div>
      <div class="feature">
        <div class="icon-container">
          <i class="fas fa-people-arrows icon"></i>
        </div>
        <div>
          <h3>Human support</h3>
          <p class="secondary-text">
            If you have any problem or anything to say, just contact us
            <a @click="$router.push({ path: '/help' })">here</a>. We're humans so we'll help you as soon as we can personally.
          </p>
        </div>
      </div>
    </div>
  </div>

  <NewsletterCTA />

  <CulDeSac />
</template>

<script>
import CulDeSac from "@/components/CulDeSac";
import NewsletterCTA from "@/components/NewsletterCTA";

export default {
  created() {
    window.scrollTo(0, 0);
  },
  components: {
    CulDeSac,
    NewsletterCTA,
  },
};
</script>

<style></style>
